import { NativeMockBackground } from '../../widgets/NativeMockBackground';
import { InstallCard } from './components/InstallCard';

export function PwaInstallSafariNativeVideo() {
  return (
    <NativeMockBackground>
      <InstallCard />
    </NativeMockBackground>
  );
}
